import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import './ProductListCartPage.css'
import ProductItem from '../ListItems/ProductItemCartPage'

const ProductListCartPage = props => {
    const history = useHistory()

    const [cartList, setCartList] = useState(JSON.parse(sessionStorage.getItem('cart')))

    let num = 1;

    const giveNumber = () => {
        if(num>3) {
            num = 1
            return num++
        }
        return num++
    }

    const onRemoveFromCartHandler = async (product) => {
        const newCartList = cartList.filter(p => p.productId !== product.productId)
        sessionStorage.setItem('cart', JSON.stringify(newCartList))
        setCartList(newCartList)
        props.reload()
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/removeFromCart`, {
                method: "POST",
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken')
                },
                body: JSON.stringify({
                    productId: product.productId
                })
            })
            if(!response.ok) {
                newCartList.push(product)
                sessionStorage.setItem('cart', JSON.stringify(newCartList))
                setCartList(newCartList)
                props.reload()
            }

        } catch(err) {
            console.log(err)
        }
    }

    return(
        <ul className="productCartList">
            {cartList.length > 0 && cartList.map(product => {
                return (
                    <ProductItem 
                    productId ={product.productId}
                    model ={product.model}
                    brand ={product.brand}
                    image ={product.image}
                    amount ={product.amount}
                    sidebarColor = {product.sidebarColor}
                    size = {product.size}
                    color = {giveNumber()}
                    onRemoveFromCartHandler = {onRemoveFromCartHandler}/>   
                )
            })}
            {cartList.length === 0 && 
                    <div className="noOrdersDiv">
                        <span>Cart is Empty !</span>
                        <div>You haven't added anything
                             to cart yet.
                             Click the button below to see products</div>
                        <img src="/images/browseProducts.svg"
                            alt="orderNowIcon"
                            onClick={() => history.push('/home')}/>
                    </div>
                }
        </ul>
    )
}

export default ProductListCartPage
